<!-- FilePreviewer.js
   The job of the file preview is to dermine the type of the file/document
   that we want to display and accordinly to that provide the appropriate
   previewer
   Written by   : Marinos - Vindico - marinos@vindico.net#
   Last Updated : 04-Oct-2020-->

<template>
    <div class="pa-0" style="height: 100%">
      <div class="ma-0 pa-0" v-if="filetype === 'video/mpeg'">
        <!-- video -->
        <video :width="width" :height="height" :src="value" controls></video>
      </div>
      <div class="ma-0 pa-0" v-else-if="filetype === 'application/pdf'" :style="{ width: width }" style="position: fixed; height:100%;">
        <!-- pdf -->
        <iframe frameBorder="0" :src="value" scrolling="auto" width="100%" height="100%" />
      </div>
      <div class="ma-0 pa-0" v-else-if="fileType === 'image/jpeg' || fileType === 'image/png' || fileType === 'image/jpg'">
          <v-img max-width="350" height="250" contain style="border-radius: 5px" :src="value"></v-img>
      </div>
       <div class="ma-0 pa-0" v-else>
        <!-- <iframe  :src="value"  frameBorder="0" scrolling="auto" width="100%" height="100%"/> -->
         <span class="appbackground--text">aaa {{value}} </span>
        <!-- <iframe :src="value"  id="myFrame" frameborder='0'>This is an embedded 
            <a target='_blank' href='http://office.com'> Microsoft Office</a> document, powered by 
            <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>
            -->
        <VueDocPreview id="ifm" :value="value" type="office" />
      </div>
      
    </div>
</template>

<script>
import VueDocPreview from 'vue-doc-preview'
export default {
  name: "FilePreviewer",
  components: {
    VueDocPreview
  },
  props: {
    fileurl: {
      type: String,
      required: false,
    },
    filetype:{
      type:String,
      required:false,
    },
    width: {
      type: String,
      default: "100%"
      },
    height: {
      type: String,
      default: "100%"
    },
    zoom: {
      type: String,
      default: "?#zoom=100%"
    }
  },
  data: () => ({
  }),
  computed: {
    value() {
      if (this.filetype === "application/octet-stream" || this.filetype === "application/vnd.ms-excel") {
        return (
          "https://view.officeapps.live.com/op/embed.aspx?src=" +
          this.fileurl + this.zoom
        );
      }else  if (this.filetype === "application/pdf") {
        return (
          this.fileurl
        );
      }else if(this.filetype ==="video/mpeg"){
          return this.fileurl;

      } else {
        var encodedUrl = encodeURIComponent(this.fileurl)
        //return ( "http://docs.google.com/gview?url=" + encodedUrl + "&embedded=true" );
        //return ("https://drive.google.com/viewerng/viewer?url=" + encodedUrl + "?pid=explorer&efh=false&a=v&chrome=false&embedded=true")
        //return ( "https://view.officeapps.live.com/op/embed.aspx?src=" + encodedUrl + "&embedded=true" );
        return encodedUrl
      }
      // if (this.fileType === 'image/jpeg' || this.fileType === 'image/png' || this.fileType === 'image/jpg') {
      //   return this.fileurl;
      // }else if (this.filetype === "application/pdf") {
      //   return (
      //     this.fileurl
      //   );
      // }else if(this.filetype ==="video/mpeg"){
      //     return this.fileurl;
      // } else {
      //   //return ( "https://docs.google.com/viewer?url=" + this.fileurl);
      //   return ( "https://view.officeapps.live.com/op/embed.aspx?src=" + this.fileurl + this.zoom );
      // }
    },
    computedHeight() {
      return '100%';
    },
  },
  methods: {
    pageY(elem) {
      return elem.offsetParent ? (elem.offsetTop + this.pageY(elem.offsetParent)) : elem.offsetTop;
    },

    resizeIframe() {
      var buffer = 20; //scroll bar buffer

      var height = document.documentElement.clientHeight;
      height -= this.pageY(document.getElementById('ifm'))+ buffer ;
      height = (height < 0) ? 0 : height;
      document.getElementById('ifm').style.height = height + 'px';
    }
  },
  mounted() {
    // var iframe = document.getElementById('ifm');
    // if (iframe.attachEvent) {
    //   iframe.attachEvent("onload", this.resizeIframe());
    // } else {
    //     iframe.onload= this.resizeIframe();
    // }

    // window.onresize = this.resizeIframe();
  }
}
</script>

<style>
    #myFrame { width:100% !important; height:700px !important; position: relative;top:0;left:0; }
    html,body {width: 100%; height: 100%; margin: 0; padding: 0}
    .hidden { font-size: 0; }
</style>